import { router } from "./router.tsx"
import { RouterProvider } from "react-router-dom"
import dayjs from 'dayjs'
import utc from "dayjs/plugin/utc"
import relativeTime from "dayjs/plugin/relativeTime"
import { loadGtag } from "./utils/gtag.ts"

dayjs.extend(relativeTime)
dayjs.extend(utc)


function App() {
    loadGtag()

    return (
        <RouterProvider router={router} />
    )
}

export default App
